import { render, staticRenderFns } from "./bulkShelvesDialog.vue?vue&type=template&id=c3c4e754&scoped=true"
import script from "./bulkShelvesDialog.vue?vue&type=script&lang=js"
export * from "./bulkShelvesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c4e754",
  null
  
)

export default component.exports